// this was autogenerated by gulpTimezonePlugin from the timezone source in node_modules
(window.__PRELOADED_TIMEZONE_DATA__ || (window.__PRELOADED_TIMEZONE_DATA__ = {}))['pt_BR']  = {
  "name": "pt_BR",
  "day": {
    "abbrev": [
      "Dom",
      "Seg",
      "Ter",
      "Qua",
      "Qui",
      "Sex",
      "Sáb"
    ],
    "full": [
      "domingo",
      "segunda",
      "terça",
      "quarta",
      "quinta",
      "sexta",
      "sábado"
    ]
  },
  "month": {
    "abbrev": [
      "Jan",
      "Fev",
      "Mar",
      "Abr",
      "Mai",
      "Jun",
      "Jul",
      "Ago",
      "Set",
      "Out",
      "Nov",
      "Dez"
    ],
    "full": [
      "janeiro",
      "fevereiro",
      "março",
      "abril",
      "maio",
      "junho",
      "julho",
      "agosto",
      "setembro",
      "outubro",
      "novembro",
      "dezembro"
    ]
  },
  "meridiem": [
    "",
    ""
  ],
  "date": "%d-%m-%Y",
  "time24": "%T",
  "dateTime": "%a %d %b %Y %T %Z",
  "time12": "",
  "full": "%a %b %e %H:%M:%S %Z %Y"
}

